<template>
  <div class="home content">

    <div class="left-side">
      <div class="left-container">
        <h2>¡Hola! Soy Nicole Loupias.</h2>
        <h1>Front End Developer y Maquetadora Web.</h1>
        <p class="subtxt">¡Navega por esta página para conocerme más!</p>
        <router-link to="/projects/one" class="projectsBtn">
            Mis proyectos
        </router-link>
      </div>

    </div>
    <div class="right-side imgHome" />

  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>
<style lang="scss" scoped>

.content .left-side {
  align-items: center;
}
.content .left-side h2 {
  font-family: 'IBM Plex Sans', sans-serif;
  color: #3F3D56;
  &::after {
    opacity: 0;
  }

 @media screen and (max-width: 1000px) {
   margin-top: 40px;
 }

}
.imgHome {
  background: url("../assets/homeImg.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;


  @media screen and (max-width: 1000px) {
    background-size: contain;
    height: 300px;
    width: 100%;

  }
}

.projectsBtn {
  display: inline-block;
  font-family: 'Space Mono', monospace;
  color: white;
  margin-top: 20px;
  border: 2px solid #3F3D56;
  font-weight: bold;
  position: relative;
  text-transform: uppercase;
  font-size: 1.05em;
  text-decoration: none;
  padding: 10px 20px;
  text-align: center;

  &::before {
      content: "";
      background-color:#f44647;
      position: absolute;
      top: -15%;
      left: -5%;
      width: 100%;
      height: 100%;
      z-index: -1;
      transition: all 0.3s ease-in-out;
  }

  &:hover:before {
    top: 0;
    left: 0;
  }
}

.content .left-side{
  @media screen and (max-width: 1000px) {
    padding: 0;

    .left-container {
      text-align: center;
    }
  }

}
</style>
